import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'

// External parsers which handle standard translating to and from Options values
// Might be worth considering a SearchspringOption class

function stringifyOption(options, key) {
  const value = options.get(key)
  if (!value) return ''

  switch (key) {
    case 'filters':
      return [...value].join(',')
    default:
      return value
  }
}

function parseOption(params, key) {
  const value = params.get(key)
  if (!value) return ''

  switch (key) {
    case 'filters':
      return new Set(value.split(','))
    case 'page':
      return parseInt(value)
    default:
      return value
  }
}

function setParamsToURL(params) {
  const origin = window.location.origin
  const pathname = window.location.pathname
  let url = `${origin}${pathname}`
  if (params.size > 0) url += `?${params.toString()}`
  window.history.replaceState({}, '', url)
}

function getParamsFromURL() {
  return new URLSearchParams(window.location.search)
}

export function useOptionsSync() {
  const { refine, options, setOptions } = useSearchspringContext()

  function setOptionToURL(key) {
    const params = getParamsFromURL()
    const value = stringifyOption(options, key)
    if (value) params.set(key, value)
    else params.delete(key)

    setParamsToURL(params)
  }

  function getOptionFromURL(key) {
    const params = getParamsFromURL()
    refine(key, parseOption(params, key))
  }

  function setAllOptionsToURL() {
    const params = new URLSearchParams()
    for (const key of options.keys()) {
      params.set(key, stringifyOption(options, key))
    }
    setParamsToURL(params)
  }

  function getAllOptionsFromURL() {
    const params = getParamsFromURL()

    setOptions((prev) => {
      const next = new Map(prev)
      for (const key of params.keys()) {
        next.set(key, parseOption(params, key))
      }
      return next
    })
  }

  return {
    getOptionFromURL,
    setOptionToURL,
    getAllOptionsFromURL,
    setAllOptionsToURL
  }
}
